"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _SingleOtpInput = _interopRequireDefault(require("./SingleOtpInput"));

var _styles2 = _interopRequireDefault(require("./styles"));

var _dec, _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// keyCode constants
var BACKSPACE = 8;
var LEFT_ARROW = 37;
var RIGHT_ARROW = 39;
var DELETE = 46;
var OtpInput = (_dec = (0, _styles.withStyles)(_styles2["default"]), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OtpInput, _React$Component);

  var _super = _createSuper(OtpInput);

  function OtpInput() {
    var _this;

    _classCallCheck(this, OtpInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeInput: 0,
      otp: []
    });

    _defineProperty(_assertThisInitialized(_this), "getOtp", function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          allowAlphabets = _this$props.allowAlphabets;

      var otp = _this.state.otp.join("");

      onChange(otp);
      return otp;
    });

    _defineProperty(_assertThisInitialized(_this), "isOtpFilled", function () {
      return _this.getOtp().length === _this.props.length;
    });

    _defineProperty(_assertThisInitialized(_this), "focusInput", function (input) {
      var length = _this.props.length;
      var activeInput = Math.max(Math.min(length - 1, input), 0);

      _this.setState({
        activeInput: activeInput
      });
    });

    _defineProperty(_assertThisInitialized(_this), "focusNextInput", function () {
      var activeInput = _this.state.activeInput;

      _this.focusInput(activeInput + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "focusPrevInput", function () {
      var activeInput = _this.state.activeInput;

      _this.focusInput(activeInput - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "changeCodeAtFocus", function (value) {
      var _this$state = _this.state,
          activeInput = _this$state.activeInput,
          otp = _this$state.otp;
      otp[activeInput] = value[0];

      _this.setState({
        otp: otp
      });

      _this.getOtp();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPaste", function (e) {
      e.preventDefault();
      var length = _this.props.length;
      var _this$state2 = _this.state,
          activeInput = _this$state2.activeInput,
          otp = _this$state2.otp; // Get pastedData in an array of max size (num of inputs - current position)

      var pastedData = e.clipboardData.getData("text/plain").slice(0, length - activeInput).split(""); // Paste data from focused input onwards

      for (var pos = 0; pos < length; ++pos) {
        if (pos >= activeInput && pastedData.length > 0) {
          otp[pos] = pastedData.shift();
        }
      }

      _this.setState({
        otp: otp
      });

      _this.getOtp();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      _this.changeCodeAtFocus(e.target.value);

      _this.focusNextInput();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnKeyDown", function (e) {
      switch (e.keyCode) {
        case BACKSPACE:
          e.preventDefault();

          _this.changeCodeAtFocus("");

          _this.focusPrevInput();

          break;

        case DELETE:
          e.preventDefault();

          _this.changeCodeAtFocus("");

          break;

        case LEFT_ARROW:
          e.preventDefault();

          _this.focusPrevInput();

          break;

        case RIGHT_ARROW:
          e.preventDefault();

          _this.focusNextInput();

          break;

        default:
          break;
      }
    });

    return _this;
  }

  _createClass(OtpInput, [{
    key: "inputs",
    get: function get() {
      var _this2 = this;

      var _this$state3 = this.state,
          activeInput = _this$state3.activeInput,
          otp = _this$state3.otp;
      var _this$props2 = this.props,
          length = _this$props2.length,
          isDisabled = _this$props2.isDisabled,
          shouldAutoFocus = _this$props2.shouldAutoFocus,
          allowAlphabets = _this$props2.allowAlphabets,
          classes = _this$props2.classes,
          label = _this$props2.label;
      return _toConsumableArray(Array(length)).map(function (_, index) {
        return /*#__PURE__*/_react["default"].createElement(_SingleOtpInput["default"], {
          key: index,
          focus: activeInput === index,
          value: otp && otp[index],
          onChange: _this2.handleOnChange,
          onKeyDown: _this2.handleOnKeyDown,
          onPaste: _this2.handleOnPaste,
          onFocus: function onFocus(e) {
            _this2.setState({
              activeInput: index
            });

            e.target.select();
          },
          onBlur: function onBlur() {
            return _this2.setState({
              activeInput: -1
            });
          },
          isDisabled: isDisabled,
          shouldAutoFocus: shouldAutoFocus,
          allowAlphabets: allowAlphabets,
          className: classes.otpInput,
          "aria-label": label + index
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex"
        },
        className: this.props.className
      }, this.inputs);
    }
  }]);

  return OtpInput;
}(_react["default"].Component), _defineProperty(_class2, "defaultProps", {
  length: 4,
  onChange: function onChange() {},
  isDisabled: false,
  shouldAutoFocus: false,
  allowAlphabets: false,
  className: "",
  label: "otp-input-"
}), _defineProperty(_class2, "propTypes", {
  length: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  isDisabled: _propTypes["default"].bool,
  shouldAutoFocus: _propTypes["default"].bool,
  allowAlphabets: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  label: _propTypes["default"].string
}), _class2)) || _class);
exports["default"] = OtpInput;